import * as React from "react";
import {
  useParams as useTanStackParams,
  useRouter as useTanStackRouter,
  useRouterState,
} from "@tanstack/react-router";

export function useRouter() {
  const router = useTanStackRouter();
  return React.useMemo(
    () => ({
      push: (href: string) => {
        router.history.push(href);
      },
      replace: (href: string) => {
        router.history.replace(href);
      },
      back: () => {
        router.history.back();
      },
      refresh: () => {
        window.location.reload();
      },
    }),
    [router],
  );
}

export function usePathname() {
  return useRouterState({ select: (state) => state.location.pathname });
}

export function useSearchParams() {
  const search = useRouterState({ select: (state) => state.location.searchStr });
  return React.useMemo(() => {
    const raw = search.startsWith("?") ? search.slice(1) : search;
    return new URLSearchParams(raw);
  }, [search]);
}

export function useParams<
  T extends Record<string, string | string[] | undefined> = Record<
    string,
    string | string[] | undefined
  >,
>() {
  return useTanStackParams({ strict: false }) as T;
}
